import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import Header from '../components/Header';

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100dvh;
  padding: 2rem;
`;

const ContentWrapper = styled.div`
  width: 100%;
  max-width: 90vw;
  margin: 0 auto;
`;

function MainLayout() {
  return (
    <div>
    <MainWrapper>
      <ContentWrapper>
        <Outlet />
      </ContentWrapper>
    </MainWrapper>
    </div>
  );
}

export default MainLayout;
